import { Form, Radio } from 'antd';
import type { RadioChangeEvent } from 'antd';

import { OPENING_CONFIGURATION_TYPE } from 'app/typings/core/admin/experiences/enum/openingConfiguration';

type Props = {
  name?: string | (string | number)[];
  constantDisabled?: boolean;
  dailyDisabled?: boolean;
  onChange?: (event: RadioChangeEvent) => void;
};

export const TypeSelector: React.FC<Props> = ({
  name,
  constantDisabled = false,
  dailyDisabled = false,
  onChange,
}) => (
  <Form.Item name={name} noStyle>
    <Radio.Group onChange={onChange}>
      <Radio
        value={OPENING_CONFIGURATION_TYPE.CONSTANT}
        disabled={constantDisabled}
      >
        Same every day
      </Radio>
      <Radio value={OPENING_CONFIGURATION_TYPE.DAILY} disabled={dailyDisabled}>
        Depends on the day
      </Radio>
    </Radio.Group>
  </Form.Item>
);
